/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import {css} from '@emotion/react';

import {LAYOUT} from '@/constants/appStyle';

import ListView from '../../view/ListView/ListView';

import './ListExplorer.less';

// TODO should setup the component prop-types
function ListExplorer(props) {
  const {listContent, callBackSelectedList, navigationType, isFullView, dataState, className, multipleSelect, height} =
    props;

  const ListExplorerStyle = css({
    // TODO the height property could be dynamic, it may good option to make the height property as component props
    /**
     * 70px comes from =>
     *  70px the profile mode selection
     */
    height: `calc(100% - ${LAYOUT.topMenuHeight} - 70px)`,
  });

  return (
    <div css={ListExplorerStyle}>
      <ListView
        height={height}
        listContent={listContent}
        callBackSelectedList={callBackSelectedList}
        navigationType={navigationType}
        isFullView={isFullView}
        dataState={dataState}
        className={className}
        multipleSelect={multipleSelect}
      />
    </div>
  );
}
export default ListExplorer;

/**
 * @enum {String}
 */
// TODO need to move this into the more common enum that follows derived enum name
export const ListViewType = {
  DEVICE: 'DEVICE',
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
};
ListExplorer.state = ListView.state;
